var _path;
import * as React from "react";
function SvgHotDrink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 20,5.5 H 4 v 10 c 0,2.21 1.79,4 4,4 h 6 c 2.21,0 4,-1.79 4,-4 v -3 h 2 c 1.11,0 2,-0.9 2,-2 v -3 c 0,-1.11 -0.89,-2 -2,-2 z m 0,5 h -2 v -3 h 2 z m -16,11 h 16 v 2 H 4 Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotDrink);
export default __webpack_public_path__ + "static/media/HotDrink.12c50cc7ac77ee159b7dff2d1be56cac.svg";
export { ForwardRef as ReactComponent };